import React, { useEffect, useState, useCallback } from 'react';

export default function useAuth() {
    const [authData, setAuthData] = useState({
      token: null,
      email: null,
      userId: null,
      isAuthenticated: false
    });
  
    useEffect(() => {
      const token = localStorage.getItem('token');
      const email = localStorage.getItem('email');
      const userId = parseInt(localStorage.getItem('userId'), 10);;
  
      setAuthData({
        token,
        email,
        userId,
        isAuthenticated: !!token
      });
    }, []);
  
    return authData;
  }